module.exports = __webpack_public_path__ + "img/waistband partly elastic width.d65b473a.png";